import { render, staticRenderFns } from "./SettingsContact.vue?vue&type=template&id=ba3aa252&scoped=true"
import script from "./SettingsContact.vue?vue&type=script&lang=js"
export * from "./SettingsContact.vue?vue&type=script&lang=js"
import style0 from "./SettingsContact.vue?vue&type=style&index=0&id=ba3aa252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3aa252",
  null
  
)

export default component.exports